import React from "react";
import {FaBox, FaSignal, FaUsers} from "react-icons/fa6";

export default function StatsOverview() {
    return (
        <section id="stats-overview" className="px-4 py-6">
            <div className="grid grid-cols-3 gap-3">
                <div className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 text-center">
                    <div className="text-primary flex justify-center text-center text-xl mb-2">
                        <FaBox></FaBox>
                    </div>
                    <p className="text-lg font-bold text-gray-900">8</p>
                    <p className="text-xs text-gray-500">Total Packages</p>
                </div>
                <div className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 text-center">
                    <div className="text-green-500 flex justify-center text-center text-2xl mb-2">
                        <FaSignal></FaSignal>
                    </div>
                    <p className="text-lg font-bold text-gray-900">247</p>
                    <p className="text-xs text-gray-500">Total Signals</p>
                </div>
                <div className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 text-center">
                    <div className="text-orange-500 flex justify-center text-center text-2xl mb-2">
                        <FaUsers></FaUsers>
                    </div>
                    <p className="text-lg font-bold text-gray-900">1,234</p>
                    <p className="text-xs text-gray-500">Subscribers</p>
                </div>
            </div>
        </section>
    );
}
